const PT = require("prop-types");
const React = require("react");
const createReactClass = require("create-react-class");
const _ = require("lodash");
const withVaultDispatch = require("../../core/hoc/withVaultDispatch");
const AT = require("../../core/vault/ActionTypes");
const OpsCart = require("../vault/OpsCart");
const StoreUtil = require("../../../shared/StoreUtil");
const Information = require("./Information");

const OrderSummary = require("./OrderSummary");
const styles = require("./styles/ShippingInfo.css");
const ShippingMethod = require("./ShippingMethod");
const ShippingCombineOrders = require("./ShippingCombineOrders");

// This view handles standard (non-paypal) orders that require shipping!

// Helper to apply higher-order components.
const augment = function(Component) {
	Component = withVaultDispatch(Component);
	return Component;
};
module.exports = augment(
	createReactClass({
		displayName: "ShippingInfo",

		propTypes: {
			cart: PT.object.isRequired,
			onContinue: PT.func,

			// Injected by HOCs
			dispatch: PT.func.isRequired,
		},

		getValidation: function() {
			const {cart} = this.props;
			return OpsCart.getGroupedStepValidation(cart, "shipping");
		},

		updateField: function(field, val) {
			this.props.dispatch({
				type: AT.UPDATE_CART_FORMDATA,
				section: "shipping",
				vals: {[field]: val},
			});
		},

		onContinue: function() {
			// Throttling done to fix T11411.
			this.doSubmit =
				this.doSubmit ||
				_.throttle(
					() => {
						const cart = this.props.cart;
						const validation = this.getValidation();

						if (validation.isComplete) {
							const canGoToNext = OpsCart.hasAlreadyPreparedOrder(cart);

							if (canGoToNext) {
								this.props.onContinue();
							} else {
								this.props.dispatch({type: AT.PREPARE_ORDER_REQUEST});
							}
						} else {
							this.props.dispatch({type: AT.SHOW_ALL_CHECKOUT_VALIDATION});
						}
					},
					500,
					{leading: true, trailing: false}
				);
			this.doSubmit();
		},

		render: function() {
			const {cart} = this.props;
			const validation = this.getValidation();
			const shippingInfo = OpsCart.getFormSection(this.props.cart, "shipping");
			const getPriceForMethod = method => {
				return OpsCart.calculateShippingPriceWithMethod(
					this.props.cart,
					method
				);
			};

			const invalidAddressGroup = validation.invalidAddressGroup;
			const showError =
				invalidAddressGroup || !_.isEmpty(validation.errorTypes);

			const preventContinue = OpsCart.needsShippingToBlockedAddress(cart);
			const items = cart.items || [];
			const booksOnly =
				items.length > 0 &&
				StoreUtil.getBookItems(items).length === items.length;

			return (
				<div className={styles.main}>
					<div className={styles.title}>{"Shipping Information"}</div>
					<div className={styles.across}>
						<div className={styles.formContainer}>
							<div className={styles.formContainer}>
								<Information
									values={_.omit(shippingInfo, ["method", "comments"])}
									updateField={this.updateField}
									initialTabIndex={1}
									errorFields={validation}
									invalidAddressGroup={invalidAddressGroup}
									addressType={"shipping"}
									splitName={booksOnly}
								/>
								<ShippingCombineOrders
									comments={shippingInfo && shippingInfo.comments}
									onCommentsChange={comments =>
										this.updateField("comments", comments)
									}
									tabIndex={0}
								/>
								<ShippingMethod
									shippingInfo={shippingInfo}
									getPriceForMethod={getPriceForMethod}
									validation={validation}
									updateField={this.updateField}
								/>
							</div>
						</div>
						<OrderSummary
							cart={cart}
							showItemize={true}
							onContinue={this.onContinue}
							showError={showError}
							buttonText="Continue"
							paypalButtonText={"Switch to"}
							tabIndex={500}
							preventContinue={preventContinue}
						/>
					</div>
				</div>
			);
		},
	})
);
